<button
  type="button"
  role="radio"
  class="sz-radio-card"
  [class.sz-radio-card--selected]="selected()"
  [class.sz-radio-card--disabled]="disabled()"
  [disabled]="disabled()"
  [attr.aria-checked]="selected()"
  (click)="emit()">
  <span class="sz-radio-card__radio" aria-hidden="true">
    <span class="sz-radio-card__radio-dot"></span>
  </span>
  <span class="sz-radio-card__body">
    <span class="sz-radio-card__label">{{ label() }}</span>
    @if (description(); as desc) {
      <span class="sz-radio-card__desc">{{ desc }}</span>
    }
  </span>
</button>
